import React, { Component } from 'react';
// import { compose } from 'redux';
// import { connect } from 'react-redux';
import { firebaseConnect } from 'react-redux-firebase';

import Header from './Header';

class Login extends Component {
  state = {
    email: '',
    password: '',
  };

  onChange = e => this.setState({ [e.target.name]: e.target.value });
  onSubmit = e => {
    e.preventDefault();

    const { firebase } = this.props;
    const { email, password } = this.state;

    firebase
      .login({
        email,
        password,
      })
      .catch(err => alert('bad login'));
  };

  render() {
    return (
      <div>
        <Header title="Login" img="/images/gallery/2013/074.jpg" />
        <section>
          <div className="container">
            <div className="row">
              <div className="col-md-12 text-center mt-5">
                <form onSubmit={this.onSubmit}>
                  <div className="row">
                    <div className="col-md-12">
                      {/* <label htmlFor="email">Naziv</label> */}
                      <input
                        type="email"
                        className="form-control u-rounded-50 p-3 u-mb-30"
                        name="email"
                        placeholder="Email"
                        required
                        value={this.state.email}
                        onChange={this.onChange}
                      />
                    </div>
                    {/* <label htmlFor="name">Password</label> */}
                    <div className="col-md-12">
                      <input
                        type="password"
                        className="form-control u-rounded-50 p-3 u-mb-30"
                        name="password"
                        placeholder="Password"
                        required
                        value={this.state.password}
                        onChange={this.onChange}
                      />
                    </div>
                  </div>
                  <button className="btn btn-rounded btn-primary" type="submit">
                    LOGIN
                  </button>
                </form>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }
}
export default firebaseConnect()(Login);



// WEBPACK FOOTER //
// ./src/components/Login.js